<template>
  <div>
    <b-modal id="PasswordResetModal"
             :title="$t('common.PasswordReset')"
             hide-footer>
      <div class="d-block text-center">
        <ValidationObserver ref="observer"
                            v-slot="{invalid}"
                            tag="form"
                            @submit.prevent="submit()">
          <ValidationProvider
            name="oldPass"
            rules="required"
            v-slot="{errors, classes}">
            <b-form-input type="password"
                          v-model="oldPass"
                          :class="{...classes, myInput: true}"
                          :placeholder="$t('common.OldPassword')" />
            <p class="myInputError">
              {{ errors[0] }}
            </p>
          </ValidationProvider>
          <ValidationProvider
            name="newPass"
            rules="required|password:newPassConfirmed"
            v-slot="{errors, classes}">
            <b-form-input type="password"
                          v-model="newPass"
                          :class="{...classes, myInput: true}"
                          :placeholder="$t('common.NewPassword')" />
            <p class="myInputError">
              {{ errors[0] }}
            </p>
          </ValidationProvider>
          <ValidationProvider
            name="newPassConfirmed"
            ref="newPassConfirmed"
            rules="required"
            v-slot="{errors, classes}">
            <b-form-input type="password"
                          v-model="newPassConfirm"
                          :class="{...classes, myInput: true}"
                          :placeholder="$t('common.NewPasswordConfirm')" />
            <p class="myInputError">
              {{ errors[0] }}
            </p>
          </ValidationProvider>
          <b-button
            type="submit"
            class="myButton align-middle">
            {{ $t("common.ChangePasswordConfirm") }}
          </b-button>
          <b-spinner
            v-if="requestSent"
            variant="primary"
            class="align-middle ml-3"
            label="Spinning" />
        </ValidationObserver>
      </div>
    </b-modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      oldPass: '',
      newPass: '',
      newPassConfirm: '',
      requestSent: false
    };
  },
  mounted() {
    this.checkPasswordReset();
  },
  methods: {
    checkPasswordReset() {
      if (this.$auth.user().setPasswordOnNextLogin) {
        this.$bvModal.show('PasswordResetModal');
      }
    },
    async submit() {
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        this.requestSent = true;
        this.sendRequest();
      }
    },
    sendRequest() {
      this.axios.post('auth/changepassword', {
        OldPassword: this.oldPass,
        NewPassword: this.newPass
      }).then(() => {
        this.requestSent = false;
        this.$bvModal.hide('PasswordResetModal');
        this.$auth.user().setPasswordOnNextLogin = false;
        const userObj = JSON.parse(localStorage.getItem('default_auth_user'));
        userObj.setPasswordOnNextLogin = false;
        localStorage.setItem('default_auth_user', JSON.stringify(userObj));
        this.$root.$bvToast.toast(this.$t('common.PasswordResetToastSuccess.Body'), {
          title: this.$t('common.PasswordResetToastSuccess.Title'),
          variant: 'success',
          toaster: 'b-toaster-top-right'
        });
      })
        .catch(() => {
          this.requestSent = false;
          this.$bvModal.hide('PasswordResetModal');
          this.$root.$bvToast.toast(this.$t('common.PasswordResetToastFailure.Body'), {
            title: this.$t('common.PasswordResetToastFailure.Title'),
            variant: 'danger',
            toaster: 'b-toaster-top-right'
          });
        });
    }
  }
};
</script>
<style scoped></style>
